// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__2HK-X","hideOnTablet":"styles_hideOnTablet__2hqUJ","hideOnMobile":"styles_hideOnMobile__1wQf1","cards":"styles_cards__3iqrg"};